import React, { Component } from 'react';
import { connect } from 'react-redux';

import EditInputElement from './EditInputElement';
import EditModalElement from './EditModalElement';

import styles from './_styles/EditSectionBlock.module.scss';

const allActionCreators = Object.assign({});

export class EditSectionDataBlock extends Component {
	
	render() {
		return <div className={`${styles.EditSectionBlock}`}>
			<div className={styles.titleWrapper}>
				<div className={styles.title}>{this.props.schema?.title}</div>
			</div>
			<div className={styles.body}>
				{this.props.schema?.fields?.map((fieldData, i) => {

					if(fieldData.hidden) {
						return null;
					}
					
					if(fieldData?.variantDisplay) {
						return <div key={i} className={`${styles.elementWrapper} ${fieldData.type === 'textarea' ? styles.fullWidth : ''}`}>
							<EditModalElement 
								product={this.props.product}
								onChange={this.props.onChange}
								fieldSchema={fieldData}
								refresh={this.props.refresh}
								apiData={this.props.apiData}
								apiDataPending={this.props.apiDataPending} />
						</div>
					}
					
					return <div key={i} className={`${styles.elementWrapper} ${fieldData.type === 'textarea' ? styles.fullWidth : ''}`}>
						<EditInputElement 
							value={this.props.editState[fieldData.stateKey]}
							onChange={this.props.onChange}
							fieldSchema={fieldData} />
					</div>
				})}
			</div>
		</div>;
	}
}

function mapStateToProps(state) {
	return {

	};
}

export default connect(mapStateToProps, allActionCreators)(EditSectionDataBlock);